import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { TabsProps, TabsState, Tabs, Tab } from '../Tabs';
import NewVendorProfilesTab2025 from './NewVendorProfilesTab2025';
import { loadNewVendorReportTab12025, loadNewVendorSharedReport2025, selectedYearChange2025, buildTitleText, getPossessiveInstitutionName, getInstitutionName } from '../../../actions/VendorReportActions2025';
import { UserVendorReportState, VendorReportAction2025 } from '../../../interface/VendorReportInterface2025';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../reducers/Index';
import NewVendorSunburst2025 from './NewVendorSunburst2025';
import ViewReportModal from '../ViewReportModal';
import MethodologyTab from './MethodologyTab';
import { isAgg } from '../../Common/Helpers';

// track user visit
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';

class NewVendorReportTabPanel2025 extends React.Component<VendorReportAction2025 & UserVendorReportState & RouteComponentProps<{}>, TabsState> {
    componentDidMount() {
        if (this.props.match.params !== undefined &&
            this.props.match.params["link_id"] !== undefined &&
            this.props.match.params["p1"] !== undefined &&
            this.props.match.params["p2"] !== undefined) {
            this.props.loadNewVendorSharedReport2025(this.props.match.params["link_id"],
                this.props.match.params["p1"],
                this.props.match.params["p2"]);
        }
        else {
            this.props.loadNewVendorReportTab12025(this.props.UserState.report_display_id, this.props.UserState.report_census_vintage, this.props.UserState.report_vintage_vendor2025);
        }
    }

    render() {
        const sharedLinkPageOnLoad = this.props.match.params !== undefined && this.props.match.params["link_id"] !== undefined && this.props.match.params["p1"] !== undefined && this.props.match.params["p2"] !== undefined;
        const agg = isAgg(this.props.UserState.report_display_id)
                    
        if (this.props.UserState.report_display_id == 999788)
            return (
                <div style={{marginTop:"40px"}}>
                    {sharedLinkPageOnLoad && (!this.props.match.params["ne"]) ? <ViewReportModal filetype={"Vendor"} /> : null}
                    {this.props.VendorReportState2025.HomeState && this.props.VendorReportState2025.TrendsPar
                        && this.props.VendorReportState2025.SunburstBVDData_Updated
                        && this.props.VendorReportState2025.SunburstBVDData != null && this.props.VendorReportState2025.SunburstBVDData.length > 0
                        && this.props.VendorReportState2025.SunburstBulletPoint != null && this.props.VendorReportState2025.VendorReport_Tab4 != null ?
                        <NewVendorSunburst2025
                            display_id={this.props.UserState.report_display_id}
                            HomeState={this.props.VendorReportState2025.HomeState}
                            industryCount={this.props.VendorReportState2025.SunburstBVDData ? this.props.VendorReportState2025.SunburstBVDData.length : 0}
                            type="BVD"
                            decoratedData={this.props.VendorReportState2025.SunburstBVDData_Updated}
                            SunburstBVDData={this.props.VendorReportState2025.SunburstBVDData}
                            SunburstBulletPoint={this.props.VendorReportState2025.SunburstBulletPoint}
                            BVDYearRange={this.props.VendorReportState2025.TrendsPar}
                            VendorReport_Tab4={this.props.VendorReportState2025.VendorReport_Tab4}
                            VendorReport={this.props.VendorReportState2025}
                            ReportsConf={this.props.VendorReportState2025.ReportsConf}
                            agg={agg}
                        /> : <div>Loading...</div>
                    }
                </div>
        )
        else
        return (
            <div>
                {sharedLinkPageOnLoad && (!this.props.match.params["ne"]) ? <ViewReportModal filetype={"Vendor"} /> : null}
                <Tabs tabIndex={1}>
                    <Tab iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link tab1'}
                        tabName="Vendor Profile"
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        shouldShow={this.props.VendorReportState2025.VendorReport_Tab12025}
                        tabIndex={0}
                        arialabel="Opening vendor profile tab"
                   >
                        <NewVendorProfilesTab2025
                            sliderChange={this.props.sliderChange}
                            selected_year={this.props.VendorReportState2025.selected_year}
                            display_id={this.props.UserState.report_display_id}
                            HomeState={this.props.VendorReportState2025.HomeState}
                            VendorProfile={this.props.VendorReportState2025.VendorProfile}
                            SpendingTotalByFips={this.props.SpendingReportState.SpendingTotalByFips}
                            TrendsPar={this.props.VendorReportState2025.TrendsPar}
                            VendorProfilesByYear={this.props.VendorReportState2025.VendorProfilesByYear}
                            BVDMatchRates={this.props.VendorReportState2025.BVDMatchRates}
                            VendorReport_Tab12025={this.props.VendorReportState2025.VendorReport_Tab12025}
                            ReportsConf={this.props.VendorReportState2025.ReportsConf}
                            agg={agg}
                            institutionName={this.props.VendorReportState2025.institutionName}
                        />
                    </Tab>
                    <Tab iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link tab4'}
                        tabName="Industry Revenue Analysis"
                        handleTabClickFromParent={this.props.handleTabClickFromParent}                        
                        arialabel="Opening industry revenue analysis tab"
                    >
                        <NewVendorSunburst2025
                            display_id={this.props.UserState.report_display_id}
                            HomeState={this.props.VendorReportState2025.HomeState}
                            industryCount={this.props.VendorReportState2025.SunburstBVDData ? this.props.VendorReportState2025.SunburstBVDData.length : 0}
                            type="BVD"
                            decoratedData={this.props.VendorReportState2025.SunburstBVDData_Updated}
                            SunburstBVDData={this.props.VendorReportState2025.SunburstBVDData}
                            SunburstBulletPoint={this.props.VendorReportState2025.SunburstBulletPoint}
                            BVDYearRange={this.props.VendorReportState2025.TrendsPar}
                            VendorReport_Tab4={this.props.VendorReportState2025.VendorReport_Tab4}
                            VendorReport={this.props.VendorReportState2025}
                            ReportsConf={this.props.VendorReportState2025.ReportsConf}
                            agg={agg}
                            institutionName={this.props.VendorReportState2025.institutionName}
                        />
                    </Tab>
                    <Tab
                        iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link tab5'}
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        tabName="Methodology"
                        arialabel="Opening methodology tab"
                    >
                        <MethodologyTab
                            display_id={this.props.UserState.report_display_id}
                            HomeState={this.props.VendorReportState2025.HomeState}
                            BVDMatchRates={this.props.VendorReportState2025.BVDMatchRates}
                            VendorReport_MatchRateTab={this.props.VendorReportState2025.VendorReport_MatchRateTab}
                            VendorReport_Tab12025={this.props.VendorReportState2025.VendorReport_Tab12025}
                            hasCensusData={this.props.VendorReportState2025.SunburstData && this.props.VendorReportState2025.SunburstData.length > 0}
                            agg={agg}
                            vendorRelease={this.props.VendorReportState2025.vendorRelease}
                            institutionName={this.props.VendorReportState2025.institutionName}
                        />
                    </Tab>
                </Tabs>
            </div>
        );
    }
}


const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    VendorReportState2025: state.vendorReportProperties2025,
    SpendingReportState: state.spendingReportProperties
});

const matchDispatchToProps = { loadNewVendorReportTab12025, loadNewVendorSharedReport2025, selectedYearChange2025, buildTitleText, getPossessiveInstitutionName, getInstitutionName };

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(withUserActionTracker(NewVendorReportTabPanel2025, "Vendor Profile Report", "landing page"));
